import { useContext } from 'react';
import { CountryAndCurrencyContext } from '../customContext/countryAndCurrencyProvider';

export function useCountryAndCurrencyCtx(){
    const ctx = useContext(CountryAndCurrencyContext);
    if(!ctx){
        throw new Error("useCountryAndCurrencyCtx must be used within the CountryAndCurrencyProvider context")
    }
    return ctx
}